module.exports = __webpack_public_path__ + "static/img/2-15-错发退货退款问题类型.2d7d2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-15-错发退货退款问题类型.png
// module id = 1350
// module chunks = 0